import { useDialogStore } from "@shared/common/contexts/dialog/useDialogStore";
import { Dialog, DialogContentContainer, ScrollContainer } from "@shared/EDS/components/Dialog";
import { JSX, useCallback } from "react";
import { ConfirmLoadPendingInstanceDialogContent } from "@opstel/dialogs/InstanceDialog/ConfirmLoadPendingInstanceDialogContent.tsx";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { usePendingInstanceData } from "./usePendingInstanceData";

export const CONFIRM_LOAD_DIALOG = "confirm-load-dialog-id";
export function ConfirmLoadPendingInstanceDialog(): JSX.Element {
  const { data, clearData } = usePendingInstanceData();
  const closeDialog = useDialogStore((state) => state.closeDialog);
  const { setCurrentInstanceId } = useCurrentInstanceId();

  const doLoadInstance = useCallback(() => {
    closeDialog(CONFIRM_LOAD_DIALOG);
    if (!data) {
      console.error("Trying to load a pending instance, but pending instance id is undefined");
      return;
    }
    setCurrentInstanceId(data.instanceId);
    clearData();
  }, [data, closeDialog, setCurrentInstanceId, clearData]);

  const doNotLoadInstance = useCallback(() => {
    closeDialog(CONFIRM_LOAD_DIALOG);
    clearData();
  }, [closeDialog, clearData]);

  return (
    <Dialog
      dialogId={CONFIRM_LOAD_DIALOG}
      title="Problemen gevonden bij inlezen plan"
      maxWidth="85svw"
    >
      <DialogContentContainer>
        <ScrollContainer $height={"calc(85vh - 20px - (20px + 20px + 24px))"}>
          <ConfirmLoadPendingInstanceDialogContent notifications={data?.notifications ?? []} />
        </ScrollContainer>
        <div className="flex justify-end gap-s px-l pt-l pb-0 [&>button]:px-[20px] [&>button]:py-xs">
          <tractie-button
            data-testid="confirm-load-pending-cancel-button"
            level="secondary"
            onClick={doNotLoadInstance}
          >
            Annuleren
          </tractie-button>
          <tractie-button
            data-testid="confirm-load-pending-continue-button"
            level="primary"
            onClick={doLoadInstance}
          >
            Doorgaan
          </tractie-button>
        </div>
      </DialogContentContainer>
    </Dialog>
  );
}
